<p-multiSelect [options]="optionValues" 
               [showToggleAll]="true" 
               [(ngModel)]="selectedValues" 
               optionLabel="label" 
               [filter]="true"
               (onChange)="onChange()">
</p-multiSelect> 